export default __webpack_public_path__ + "static/media/red_rocket.d815f373.svg";